import { uiRows } from './types-def.js';
/**
 * `web/run` (2.E). Run-mode writes go through ordinary routes: there is no offline pack, outbox
 * or retry queue (PLAN section 5 #3).
 */
export const RUN_INTERACTIONS = uiRows([
    {
        id: 'run.commands.keyboard',
        module: 'web/run',
        behavior: 'J, K, 1, 2, 3, O, R and Mod-J work without a pointer and each write is acknowledged',
        owner: '2.E',
        since: 'exit-2b',
    },
    // CS r5a deliverable 149: every Run-mode action by a visible control (DECISIONS 161). The
    // brief's `run.reveal`, `run.table-view` and `run.banner` take a third part for the id grammar,
    // as their test ids have it.
    {
        id: 'run.play.mark',
        module: 'web/run',
        behavior: 'Played, Skipped and Diverged on the current item record its mark',
        owner: '2.E',
        since: 'exit-2b',
    },
    {
        id: 'run.capture.log',
        module: 'web/run',
        behavior: "The capture box and its kind choice add a capture to the session's log",
        owner: '2.E',
        since: 'exit-2b',
    },
    {
        id: 'run.clock.advance',
        module: 'web/run',
        behavior: 'Long rest, +1 hour, Travel and a custom advance on the clock bar move NOW',
        owner: '2.E',
        since: 'exit-2b',
    },
    {
        id: 'run.clock.undo',
        module: 'web/run',
        behavior: '"Undo last advance" on the clock bar takes back the latest advance',
        owner: '2.E',
        since: 'exit-2b',
    },
    {
        id: 'run.secret.reveal',
        module: 'web/run',
        behavior: '"Reveal" on a secret records it as tentatively known',
        owner: '2.E',
        since: 'exit-2b',
    },
    {
        id: 'run.reveal.undo',
        module: 'web/run',
        behavior: '"Undo" beside a reveal takes it back',
        owner: '2.E',
        since: 'exit-2b',
    },
    {
        id: 'run.table-view.open',
        module: 'web/run',
        behavior: '"Table view" opens the current scene\'s page as the table sees it, in a new window',
        owner: '2.E',
        since: 'exit-2b',
    },
    {
        id: 'run.banner.unreachable',
        module: 'web/run',
        behavior: 'A banner says when the server cannot be reached and goes once it answers again',
        owner: '2.E',
        since: 'exit-2b',
    },
    {
        id: 'run.session.end',
        module: 'web/run',
        behavior: '"End session" ends the session and opens After',
        owner: '2.E',
        since: 'exit-2b',
    },
    {
        id: 'run.capture.edit',
        module: 'web/run',
        behavior: "A capture's Edit and Remove buttons change or remove it",
        owner: '2.E',
        since: 'exit-2b',
    },
]);
//# sourceMappingURL=run.js.map